// C:\IntegraNube_WebStore\src\components\Menu.js
'use strict';

import React from 'react';

/**
 * La navegación principal ahora vive dentro de Header.js.
 *
 * Se conserva este componente porque App.js ya lo importa/renderiza,
 * pero no genera una segunda barra de navegación.
 */
export default function Menu() {
  return null;
}
